import { BaseAPIModel } from '@weezevent/weezjs-core';
import { Session } from '.';

export default class SessionGroup extends BaseAPIModel {
    static fromJSON(args) {
        const group = super.fromJSON(args);
        group.sessions = this.children.map(session => Session.fromJSON(session));
        return group;
    }

    // Get the select options object for this group
    toOption(custom) {
        return {
            text: this.name,
            value: this.id,
            ...custom?.(this)
        };
    }
}
